import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/t&c_banner.png"; // Replace with actual path
function TermsCond() {
  return (
    <div className="terms-privacy">
      <HeroSection image={Banner} pageTitle="Terms & Conditions" />
      <section>
        <div className="container-fluid">
          <div className="py-3">
            <h4>Introduction</h4>
            <p>
              Welcome to SAMS Digital. By accessing and using our website, you
              agree to comply with the following terms and conditions. If you do
              not agree, please refrain from using our services.
            </p>
          </div>
          <hr></hr>
          <div className="py-3">
            <h4>Services</h4>
            <p>
              We provide event management solutions, including corporate events,
              book publication events, conferences, and more. The details of our
              services are outlined on our website and may be updated
              periodically.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>User Responsibilities</h4>
            <p>
              Users must provide accurate and complete information when
              interacting with our services. <br />
              Any misuse, unauthorized access, or breach of our website’s
              security is strictly prohibited. <br />
              Users shall not copy, distribute, or modify any content from this
              website without prior written permission.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Intellectual Property</h4>
            <p>
              All content, including logos, designs, images, and text, is the
              property of [Your Company Name] unless stated otherwise.
              Unauthorized use of our intellectual property is not permitted.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Event Cancellations & Modifications</h4>
            <p>
              We reserve the right to cancel, reschedule, or modify events due
              to unforeseen circumstances. Clients will be informed promptly of
              any such changes.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Third-Party Links</h4>
            <p>
              Our website may include links to third-party websites. We are not
              responsible for their content, privacy policies, or practices.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Limitation of Liability</h4>
            <p>
              We strive to provide high-quality services, but we are not liable
              for any losses, damages, or unforeseen issues arising from the use
              of our website or event services.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Privacy Policy</h4>
            <p>
              Your privacy is important to us. Please refer to our Privacy
              Policy for details on how we collect, use, and protect your
              personal data.
            </p>
          </div>
          <hr></hr>

          <div className="py-3">
            <h4>Amendments</h4>
            <p>
              We reserve the right to update or modify these terms and
              conditions at any time. Users are encouraged to review them
              periodically.
            </p>
          </div>
          <hr></hr>

          <div>
            <h4>Contact Us</h4>
            <p>
              For any questions regarding these terms, please contact us at:
            </p>
            <p>
              <span className="fw-semibold">Email:</span> sales@samsdigital.in
            </p>
            <p>
              <span className="fw-semibold">Phone:</span> +91 7093970147
            </p>
            <p>
              <span className="fw-semibold">Website: </span> www.samsdigital.in
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsCond;
